import {
    initDimensionsFromState,
    trackAnalyticsEvent as trackGoogleAnalyticsEvent,
    trackInitialPageView,
} from '@eventbrite/site-analytics';
import {
    getAmplitudeInstance,
    identifyIntercom,
    intercomUpdate,
    loadAmplitude,
    loadIntercom,
} from './analytics-base/analytics';
import { AnalyticsCategory, TrackingServices } from './analytics-enums';
import {
    Actions,
    Components,
    Features,
    Teams,
} from './analytics-enums/heap-atributes';
import {
    AnalyticsAction,
    AnalyticsCategoryType,
    HeapDataAttribute,
    IntercomUpdateKeyType,
} from './types';

const ALL_TRACKING_SERVICES = [
    TrackingServices.GoogleAnalytics,
    TrackingServices.Amplitude,
    TrackingServices.Intercom,
];

// You'll want to call this in your apps index file with window.__SERVER_DATA__
const initTrackingServices = (
    serverData: any = {},
    trackingServices: Array<TrackingServices> = ALL_TRACKING_SERVICES,
) => {
    if (typeof window === 'undefined') return;

    if (trackingServices.includes(TrackingServices.GoogleAnalytics)) {
        initDimensionsFromState(serverData);
        trackInitialPageView(serverData.gaSettings);
    }
    if (trackingServices.includes(TrackingServices.Amplitude)) {
        loadAmplitude();
    }
    if (trackingServices.includes(TrackingServices.Intercom)) {
        loadIntercom();
        identifyIntercom();
    }
};

const trackMarketingEvent = ({
    action,
    eventSource = '',
    category = AnalyticsCategory.default,
    dimensions = {},
}: {
    action: AnalyticsAction;
    eventSource: string;
    category: AnalyticsCategoryType;
    dimensions?: { [key: string]: any };
}) => {
    if (typeof window === 'undefined') return;

    if (!window.ga || !window.amplitude) {
        initTrackingServices(window.__SERVER_DATA__, [
            TrackingServices.GoogleAnalytics,
            TrackingServices.Amplitude,
        ]);
    }

    trackGoogleAnalyticsEvent({
        action,
        label: eventSource,
        category,
        dimensions,
    });
    getAmplitudeInstance().logEvent(category, {
        action,
        source: eventSource,
        ...dimensions,
    });
};

const updateIntercom = (params: {
    [key in IntercomUpdateKeyType]?: any;
}) => {
    if (typeof window === 'undefined') return;
    const _window = window as Window &
        typeof globalThis & { Intercom: () => {} };

    if (!_window.Intercom) {
        initTrackingServices(window.__SERVER_DATA__, [
            TrackingServices.Intercom,
        ]);
    }

    intercomUpdate(params);
};

const getHeapDataAttribute = (params: {
    team: Teams;
    feature: Features;
    component: Components;
    action: Actions;
}): HeapDataAttribute => {
    const { team, feature, component, action } = params;

    return `${team}-${feature}-${component}-${action}`;
};

export {
    trackMarketingEvent,
    initTrackingServices,
    updateIntercom,
    getHeapDataAttribute,
};
